import * as React from 'react';
// @ts-ignore
import ErrorIcon from '../../assets/errorImage.svg';
import { polyglot } from '../../helpers/Polyglot';
import { LocalesKeys } from '../../localesKeys';
import { Logo } from '../Logo/Logo';
import styles from './ErrorPage.scss';

export interface ErrorPageProps {
    errorTitle?: string;
    errorMessage?: string;
    errorDetails?: string;
}

export const ErrorPage = ({errorTitle, errorMessage, errorDetails}: ErrorPageProps) => {
    return(
        <div className={styles.ErrorPageContainer}>
            <div className={styles.Header}><Logo /></div>
            <div className={styles.ErrorTitle}>{errorTitle || polyglot.t(LocalesKeys.activationUnknownErrorTitle)}</div>
            <div className={styles.ErrorContent}>
                <div className={styles.ErrorImage}>
                    <img src={ErrorIcon} />
                </div>
                <div className={styles.ErrorDescription}>
                    <div>{errorMessage || polyglot.t(LocalesKeys.activationUnknownErrorMessage)}</div>
                    {errorDetails && <pre>{errorDetails}</pre>}
                </div>
            </div>
            <div className={[styles.WrapperFooter, styles.FlexContentRight].join(' ')}>
                <a target='_blank' href='https://support.goto.com/meeting/help/how-do-i-activate-my-gotoroom-device' className={styles.ExternalLink}>{polyglot.t(LocalesKeys.support)}</a>
            </div>
        </div>
    );
};
